import { render, staticRenderFns } from "./WizardPanel.vue?vue&type=template&id=622838f6&"
import script from "./WizardPanel.vue?vue&type=script&lang=js&"
export * from "./WizardPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports